import { render, staticRenderFns } from "./ArchivedOrderList.vue?vue&type=template&id=3fe47d7f&"
import script from "./ArchivedOrderList.vue?vue&type=script&lang=ts&"
export * from "./ArchivedOrderList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports